import React, { useEffect, useRef, useState } from "react";
import Layout from "../../Components/Layout/Layout";
import { useNavigate } from "react-router-dom";
import {
  useDeleteAdminMutation,
  useEditAdminMutation,
  useGetAdminsQuery,
} from "../../store/Api/admins";
import { hidetoast, useDecodeToken } from "../../Utils/function";
import { useGetRrbQuery } from "../../store/Api/common";
import AuditsQuestionsUi from "./AuditsQuestionsUi";
import {
  useDeleteAuditQuestionMutation,
  useEditAuditQuestionMutation,
  useGetAuditsQuestionsQuery,
  useReoderAuditQuestionMutation,
} from "../../store/Api/auditsQuestions";
import { render } from "@testing-library/react";
import { useDispatch, useSelector } from "react-redux";
import  {rowsPerPage} from '../../Utils/constant'

function AuditsQuestions() {
  const navigate = useNavigate();
  const [deleteId, setDeleteId] = useState("");
  const decodedToken = useDecodeToken();
  const [tableQaury, setTableQaury] = useState({
    search: "",
    rowsPerPage: rowsPerPage,
    currentPage: 1,
    rrbId: decodedToken?.role == 1 ? `${decodedToken?.rrb_id}` : "",
  });
  const [deleteAuditQuestion] = useDeleteAuditQuestionMutation();
  const [reoderAuditQuestion] = useReoderAuditQuestionMutation();

  const { data, isFetching, isLoading, refetch } = useGetAuditsQuestionsQuery({
    search: tableQaury.search,
    limit: tableQaury.rowsPerPage,
    page: tableQaury.currentPage,
  });
  const [dragId, setDragId] = useState();
  const [boxes, setBoxes] = useState([]);
  const dispatch = useDispatch();
  const toast = useSelector((state) => state.toast);

  // Auto-hide toast after 3 seconds
 useEffect(() => {
    if (toast.message) {
       hidetoast()
    }
  }, [toast.message, dispatch]);
  //   const [boxes, setBoxes] = useState([
  //     {
  //       question: {
  //         id: "Box-1",
  //         question: "How Are you?",
  //         input_type: "text",
  //         reference_para: "5.3.1.1",
  //         dropdown_type: "",
  //         answer: "i am fine",
  //         mandatory: true,
  //         checkbox_type: "",
  //         options: [""],
  //         multiline: "",
  //         sequence: 1,
  //         sub_question: [
  //           {
  //             question: "",
  //             input_type: "",
  //             dropdown_type: "",
  //             mandatory: "",
  //             multiline: "",
  //             checkbox_type: "",
  //             options: [""],
  //             answer: "",
  //           },
  //         ],
  //       },
  //     },
  //     {
  //       question: {
  //         id: "Box-2",
  //         question: "What is your Graduations?",
  //         input_type: "checkbox",
  //         dropdown_type: "",
  //         answer: "",
  //         reference_para: "",
  //         mandatory: "",
  //         checkbox_type: "multiple",
  //         options: [""],
  //         multiline: "",
  //         sequence: 2,
  //         sub_question: [
  //           {
  //             question: "You are 10th Pass?",
  //             input_type: "radio",
  //             dropdown_type: "",
  //             mandatory: true,
  //             multiline: "",
  //             checkbox_type: "",
  //             options: ["y", "n"],
  //             answer: "y",
  //           },
  //           {
  //             question: "You are 12th Pass?",
  //             input_type: "radio",
  //             dropdown_type: "",
  //             mandatory: "",
  //             multiline: "",
  //             checkbox_type: "",
  //             answer: "yes",
  //             options: ["yes", "no"],
  //           },
  //           {
  //             question: "You are Clg Pass?",
  //             answer: "no",
  //             input_type: "radio",
  //             dropdown_type: "",
  //             mandatory: "",
  //             multiline: "",
  //             checkbox_type: "",
  //             options: ["yes", "no"],
  //           },
  //         ],
  //       },
  //     },
  //     {
  //       question: {
  //         id: "Box-3",
  //         question: "You are playing cricket",
  //         input_type: "radio",
  //         reference_para: "",
  //         dropdown_type: "",
  //         answer: "yes",
  //         mandatory: "",
  //         checkbox_type: "",
  //         options: ["yes", "no"],
  //         multiline: "",
  //         sequence: 3,
  //         sub_question: [
  //           {
  //             question: "",
  //             input_type: "",
  //             dropdown_type: "",
  //             mandatory: "",
  //             multiline: "",
  //             checkbox_type: "",
  //             answer: "",
  //             options: [""],
  //           },
  //         ],
  //       },
  //     },
  //     {
  //       question: {
  //         id: "Box-4",
  //         question: "What are you doing?",
  //         input_type: "text",
  //         reference_para: "",
  //         dropdown_type: "",
  //         answer: "playing crickt",
  //         mandatory: true,
  //         checkbox_type: "",
  //         options: [""],
  //         multiline: "",
  //         sequence: 4,
  //         sub_question: [
  //           {
  //             question: "",
  //             input_type: "",
  //             dropdown_type: "",
  //             mandatory: "",
  //             multiline: "",
  //             checkbox_type: "",
  //             options: [""],
  //             answer: "",
  //           },
  //         ],
  //       },
  //     },
  //     {
  //       question: {
  //         id: "Box-5",
  //         question: "You are playing chess",
  //         input_type: "checkbox",
  //         dropdown_type: "",
  //         answer: "no",
  //         reference_para: "",
  //         mandatory: "",
  //         checkbox_type: "single",
  //         options: ["yes", "no"],
  //         multiline: "",
  //         sequence: 5,
  //         sub_question: [
  //           {
  //             question: "",
  //             input_type: "",
  //             dropdown_type: "",
  //             mandatory: "",
  //             multiline: "",
  //             checkbox_type: "",
  //             answer: "",
  //             options: [""],
  //           },
  //         ],
  //       },
  //     },
  //     {
  //       question: {
  //         id: "Box-6",
  //         question: "You are playing kabbdi",
  //         input_type: "checkbox",
  //         dropdown_type: "",
  //         answer: "yes",
  //         reference_para: "",
  //         mandatory: "",
  //         checkbox_type: "single",
  //         options: ["yes", "no"],
  //         multiline: "",
  //         sequence: 6,
  //         sub_question: [
  //           {
  //             question: "",
  //             input_type: "",
  //             dropdown_type: "",
  //             mandatory: "",
  //             multiline: "",
  //             checkbox_type: "",
  //             answer: "",
  //             options: [""],
  //           },
  //         ],
  //       },
  //     },
  //     {
  //       question: {
  //         id: "Box-7",
  //         question: "You are playing kabbdi",
  //         input_type: "dropdown",
  //         dropdown_type: "custom",
  //         answer: "",
  //         mandatory: "",
  //         reference_para: "",
  //         checkbox_type: "",
  //         options: ["yes", "no"],
  //         multiline: "",
  //         sequence: 7,
  //         sub_question: [
  //           {
  //             question: "",
  //             input_type: "",
  //             dropdown_type: "",
  //             mandatory: "",
  //             multiline: "",
  //             checkbox_type: "",
  //             answer: "",
  //             options: [""],
  //           },
  //         ],
  //       },
  //     },
  //     {
  //       question: {
  //         id: "Box-8",
  //         question: "You are playing kabbdi",
  //         input_type: "dropdown",
  //         dropdown_type: "numeric",
  //         answer: "0",
  //         mandatory: "",
  //         reference_para: "",
  //         min: 0,
  //         max: 10,
  //         checkbox_type: "",
  //         options: [""],
  //         multiline: "",
  //         sequence: 8,
  //         sub_question: [
  //           {
  //             question: "",
  //             input_type: "",
  //             dropdown_type: "",
  //             mandatory: "",
  //             multiline: "",
  //             checkbox_type: "",
  //             answer: "",
  //             options: [""],
  //           },
  //         ],
  //       },
  //     },
  //   ]);
  useEffect(() => {
    const subFn = (val) => {
        let data = [];
        if (val?.length >= 1 && val[0] !== "") {
          data = val?.map((subVal) => {
            return {
              ...subVal,
              answer: JSON.parse(subVal?.answer),
              options: JSON.parse(subVal?.options),
            };
          });
        } else {
          data = [];
        }
        return data;
      };
    const questionData = data?.data?.map((item) => ({
      ...item,
      answer: JSON.parse(item?.answer),
      options: JSON.parse(item?.options),
      sub_question: subFn(item?.sub_question),
    }));
   
    setBoxes(questionData);
  }, [data]);
  const containerRef = useRef(null);
  const handleDrag = (ev) => {
    setDragId(ev.currentTarget.id);
  };

  //   const handleDrop = (ev) => {
  //     const dragBox = boxes.find((box) => box.id === dragId); // The box being dragged
  //     const dropBox = boxes.find((box) => box.id === ev.currentTarget.id); // The box being dropped on

  //     // Filter out the dragged box and find its current index
  //     const updatedBoxes = boxes.filter((box) => box.id !== dragId);

  //     // Find the index of the dropBox in the filtered array
  //     const dropIndex = updatedBoxes.findIndex((box) => box.question.id === dropBox.id);

  //     // Insert the dragBox at the dropBox's position
  //     updatedBoxes.splice(dropIndex, 0, dragBox);

  //     // Update the order based on the new array position
  //     const reorderedBoxes = updatedBoxes.map((box, index) => ({
  //       ...box,
  //       order:index + 1,
  //     }));

  //     setBoxes(reorderedBoxes);
  //   };
  const handleDrop = async (ev) => {
    // The box being dragged
    const dragBox = boxes.find((box) => box?.id == parseInt(dragId));
    const dropBox = boxes.find(
      (box) => box.id === parseInt(ev.currentTarget.id)
    ); // The box being dropped on
    // Remove the dragged box from its current position
    const updatedBoxes = boxes.filter((box) => box?.id !== parseInt(dragId)); // Filter out null values and the dragged box

    //  updatedBoxes.filter((box) => box !== null);
    // Find the index of the dropBox in the filtered array
    const dropIndex = updatedBoxes?.findIndex((box) => box?.id === dropBox?.id);

    // Insert the dragged box at the drop position
    updatedBoxes.splice(dropIndex, 0, dragBox);

    // Update the sequence based on the new positions

    const reorderedBoxes = updatedBoxes.map((box, index) => ({
      ...box,
      sequence: index + 1,
    }));
    const newData = [];
    reorderedBoxes?.map((val) => {
      newData.push({
        id: val?.id,
        sequence: val?.sequence,
      });
    });
    let questionsArr = {
      questions: newData,
    };

    try {
      const response = await reoderAuditQuestion({
        questions: questionsArr,
      });
      if (response?.data?.success) {
        refetch(); // Refresh the user list after updating
      }
    } catch (error) {
      console.error(error, "Error updating audit qeutions status");
    }
    // setBoxes(reorderedBoxes); // Update state
  };
  const handleDragOver = (ev) => {
    ev.preventDefault();

    const container = containerRef.current;
    if (!container) return;

    const { top, bottom } = container.getBoundingClientRect();
    const offset = 20; // Pixels near the edge to trigger scrolling
    const scrollSpeed = 10; // Speed of scrolling

    if (ev.clientY < top + offset) {
      // Scroll up
      container.scrollBy(0, -scrollSpeed);
    } else if (ev.clientY > bottom - offset) {
      // Scroll down
      container.scrollBy(0, scrollSpeed);
    }
  };
  const onUpdate = async (row) => {
    navigate(`/update-audit-question`, { state: row });
  };
  const onView = async (row) => {
    navigate(`/view-audit-question/${row?.id}`, { state: { row } });
  };

  const deleteFn = async () => {

    try {
      const response = await deleteAuditQuestion({ id: deleteId });
      if (response?.data?.success) {
        // Call refetch to refresh the user list
        refetch();
      }
    } catch (error) {
      console.log(error, "verify otp error");
    }
  };
  const handlePageChange = (newPage) => {
    // setCurrentPage(newPage);
    setTableQaury({ ...tableQaury, currentPage: newPage });
  };
  const columns = [
    { title: "Question", dataKey: "firstname" },
    {
      title: "Mandatory",
      render: (_, row) => (
        <div className="form-group mb-0 d-flex justify-content-center">
          <div className="custom-control custom-switch">
            <input
              type="checkbox"
              className="custom-control-input"
              id={`userStatusSwitch-${row.id}`}
              checked={row.status}
              //   onChange={(e) => onMandatoryUpdate(row.id, e.target.checked)}
            />
            <label
              className="custom-control-label"
              htmlFor={`userStatusSwitch-${row.id}`}
            ></label>
          </div>
        </div>
      ),
    },
    {
      title: "Actions",
      render: (_, row) => (
        <div className="d-flex">
          <button
            className="border-0 bg-transparent"
            onClick={() => onView(row)}
          >
            <i class="fas fa-eye text-primary"></i>
          </button>
          <button
            className="border-0 bg-transparent"
            type="button"
            onClick={() => onUpdate(row)}
          >
            <i className="fas fa-edit text-success"> </i>
          </button>
          <button
            className="border-0 bg-transparent"
            type="button"
            // data-toggle="modal"
            // data-target="#modal-danger"
          >
            <i className="fas fa-trash text-danger"> </i>
          </button>
        </div>
      ),
    },
  ];


  return (
    <Layout>
      <AuditsQuestionsUi
        columns={columns}
        data={boxes || []}
        // data={boxes}
        totalRecords={data?.data?.totalItems}
        onUpdate={onUpdate}
        loading={isLoading}
        tableQaury={tableQaury}
        deleteAdminFn={deleteFn}
        onPageChange={handlePageChange}
        setTableQaury={setTableQaury}
        decodedToken={decodedToken}
        handleDrag={handleDrag}
        handleDrop={handleDrop}
        containerRef={containerRef}
        handleDragOver={handleDragOver}
        setDeleteId={setDeleteId}
        toast={toast}
      />
    </Layout>
  );
}

export default AuditsQuestions;
